import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { getQuarantineUrl } from 'FormsUI/lib/RouteGenerators';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuarantineAction = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsxs(UIButton, {
    use: "secondary",
    href: getQuarantineUrl(),
    onClick: () => trackDashboardInteraction('go-to-submissions-spam-actions'),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.spam"
    }), /*#__PURE__*/_jsx(UIBadge, {
      className: "m-left-4",
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "beta"
      })
    })]
  })]
});
export default QuarantineAction;